<div class="row">
  <div class="col-12 col-lg-12 text-center py-5">
    <!--<img src="assets/img/logo.png" class="w-50 animated zoomIn">-->
    <img class="w-50 animated zoomIn"  alt="" [src]="'data:image/jpg;base64,'+configuracion.logoPrincipalFuncionarioConsumos">
  </div>
  <div class="col-12 col-lg-12 text-center">
    <h1 class="indigo-text animated zoomIn">Bienvenido a la <br>Administración del Portal</h1>
  </div>
</div>
